import React, {Component} from 'react';
import {connect} from "react-redux";
import {PropTypes} from "prop-types";

import JBasic from "./module/0_Basic";
import JBasicMeta from "./module/1_BasicMeta";
import JImpactFactor from "./module/2_ImpactFactor";
import JInformation from "./module/3_Information";
import JImpactFactorChange from "./module/4_ImpactFactorChange";
import JCategoryRank from "./module/5_CategoryRank";
import JMeta from "./module/6_Meta";
import JAlticle from "./module/9_Article";
import JDepartments from "./module/7_Departments";

class JournalContent extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		const record = this.props.record;
		const meta = this.props.meta;

		if(!record.journal_id)
			return ''
		return (
			<div className="center-group">
				<JBasic record={record}/>
				<JBasicMeta record={record}/>
				<JImpactFactor meta={meta}/>
				<JInformation record={record}/>
				<JImpactFactorChange meta={meta}/>
				<JCategoryRank meta={meta}/>
				<JMeta record={record}/>
				<JDepartments record={record}/>
				{/*<JResearchers />*/}
				<JAlticle record={record}/>
			</div>
		)
	}
}

export default connect(
	(state) => ({
		record: state.journals.record ? state.journals.record : {},
		meta: state.journals.meta ? state.journals.meta : {},
	}),
	(dispatch) => ({
		// dataActions: bindActionCreators(Actions, dispatch)
	}),
)(JournalContent)

JournalContent.propTypes = {
	// args : PropTypes.object,
	// facet : PropTypes.object,
};
